import { Routes, Route, Navigate } from "react-router-dom";
import Navigation from "../../../components/Navigation/Navigation.js";
import Individual from "./Personal/PersonalView.js";
import NationalView from "./National/NationalView.js";
import { useTranslation } from "react-i18next";

const Overall = () => {
  const { t } = useTranslation();
  const tabs = [
    { path: "personal", label: t('nav.individual') },
    { path: "national", label: t('nav.country') },
  ];

  return (
    <>
      <Navigation tabs={tabs} basePath="/match-results/overall" variant="tab" />

      <Routes>
        <Route path="/" element={<Navigate to="personal" replace />} />
        <Route path="personal/" element={<Individual />} />
        <Route path="national/" element={<NationalView />} />
      </Routes>
    </>
  );
};
export default Overall;
